const STYLES = {
  completed: "bg-green-100 text-green-700",
  partial: "bg-amber-100 text-amber-800",
  failed: "bg-red-100 text-red-700",
};

export default function StatusBadge({ status }) {
  return (
    <span data-testid={`status-badge-${status}`} className={`inline-block px-2 py-0.5 rounded-full text-xs font-semibold capitalize ${STYLES[status] || "bg-slate-100 text-slate-700"}`}>
      {status}
    </span>
  );
}
